import React from 'react'

function EmptyDataComponent() {
  return (
    <div className='d-flex justify-content-center align-items-center' style={{marginTop:'200px', marginBottom:'200px'}}>
      <h1 style={{justifyContent:'center'}}>No data found</h1>
    </div>
  )
}

export default EmptyDataComponent;
